import moment from "moment";

export const downloadBlob = (
  blob: Blob,
  fileName: string,
  timestamp: boolean = false
) => {
  try {
    const a = document.createElement("a");
    const blobURL = window.URL.createObjectURL(blob);
    a.href = blobURL;
    a.setAttribute(
      "download",
      timestamp
        ? fileName + moment().local().format("YYYYMMDDhhmmss")
        : fileName
    );
    document.body.appendChild(a);
    a.click();
    return true;
  } catch {
    return false;
  }
};
